import { render } from "./GroupValuesTable.vue?vue&type=template&id=21945907&ts=true"
import script from "./GroupValuesTable.vue?vue&type=script&lang=ts"
export * from "./GroupValuesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__